// extracted by mini-css-extract-plugin
export var statItem = "_li-1";
export var statsRow = "_li-0";